.detailsContainer {
    display: flex;
}

.detailsDateContainer {
    display: flex;
    align-items: center;
    margin-left: 10px;
}

.detailsOrganizationName {
    display: flex;
    align-items: center;
    margin-right: 10px;
}